<template>
  <div class="share-bill-link__wrapper">
    <base-popup
      class="share-bill-link"
      ref="popup"
      v-show="!notificationShowing"
      :without-icon="true"
    >
      <template #header="{ close }">
        <div class="share-bill-link__header">
          <div class="share-bill-link__title">
            {{ $t('bills.popup.share-bill-link.title') }}
          </div>
          <popup-close-button
            class="share-bill-link__close"
            @click="close"
          ></popup-close-button>
        </div>
      </template>
      <template #content>
        <social-share-buttons
          class="share-bill-link__buttons"
          :url-to-share="template.TemplateUrl"
          :content-to-share="''"
        ></social-share-buttons>
        <div class="share-bill-link__input">
          <link-input
            :disabled="true"
            title="Link"
            v-model:value="template.TemplateUrl"
            :can-copy="true"
            @copied="handleLinkCopied"
          ></link-input>
        </div>
      </template>
    </base-popup>
    <success-notification
      ref="billLinkCopiedNotification"
      :text="$t('bills.popup.share-bill-link.notifications.copied')"
    ></success-notification>
  </div>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PopupCloseButton from '@vue-app/components/base/button/PopupCloseButton.vue'
import SocialShareButtons from '@vue-app/components/base/share/SocialShareButtons.vue'
import LinkInput from '@vue-app/components/base/input/LinkInput.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import { Bill } from '@js-app/entities/Bill'

export default {
  name: 'ShareBillTemplateLinkPopup',
  components: {
    SuccessNotification,
    LinkInput,
    SocialShareButtons,
    PopupCloseButton,
    BasePopup,
  },
  props: {
    template: Object,
  },

  data() {
    return {
      notificationShowing: false,
    }
  },
  methods: {
    open() {
      return this.$refs.popup.open()
    },
    async handleLinkCopied() {
      this.notificationShowing = true
      await this.$refs.billLinkCopiedNotification.show()

      this.notificationShowing = false
    },
  },
}
</script>

<style lang="scss" scoped>
.share-bill-link {
  :deep(.popup) {
    width: 395px;
    padding: 30px 0 52px;

    .popup__actions {
      display: none;
    }
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 30px;
    margin-bottom: 44px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #585f6d;
  }

  &__close {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__buttons {
    padding: 0 70px;
  }

  &__input {
    margin-top: 60px;
    padding: 0 52px;
  }
}
</style>
